import { render } from "./formDataSelect.vue?vue&type=template&id=5fc63a5e"
import script from "./formDataSelect.vue?vue&type=script&lang=js"
export * from "./formDataSelect.vue?vue&type=script&lang=js"

import "./formDataSelect.vue?vue&type=style&index=0&id=5fc63a5e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__